<template>
    <div>
        <button
            v-can:create-model="'dossier'"
            v-btn-loading="saving"
            class="btn btn-primary mr-2 mb-2"
            @click="addClicked"
        >
            Ajouter un {{ options && options.type ? options.type : 'dossier' }}
        </button>

        <SelectionTypeDossierModal
            v-if="showModalTypeDossier"
            @next-step="createNewDossier($event.type)"
            @close="showModalTypeDossier = false"
        />
    </div>
</template>

<script>
    import SelectionTypeDossierModal from "../modals/SelectionTypeDossierModal"

    export default {
        name: "DossierCreate",

        components: {SelectionTypeDossierModal},

        props: {
            options: { type: Object, default: null },
        },

        data: function () {
            return {
                saving: false,
                showModalTypeDossier: false,
            }
        },

        methods: {
            addClicked: function () {
                if (this.options && this.options.type === 'prospect') {
                    return this.createNewDossier(this.options.type)
                }
                this.showModalTypeDossier = true
            },

            createNewDossier: function (type) {
                this.saving = true

                const template = 'Vous avez généré ' + ('dossier' !== type ? `un nouveau ${type}.` : 'une nouvelle fiche de création.')
                axios.post('/api/dossiers', {...this.options, type})
                    .then(response => {
                        this.$notify('success', template)
                        this.showModalTypeDossier = false
                        this.$router.push({name: 'dossier', params: {id: response.data.id}})
                    })
                    .catch(() => this.$notify('danger', 'Une erreur est survenue lors de la génération, veuillez contacter le support'))
                    .finally(() => this.saving = false)
            }
        }
    }
</script>
